import React from "react";
import styles from "./Navbar.module.scss";
import logo1 from "../../images/IMG_1969.PNG";
import logo2 from "../../images/IMG_1971.PNG";
import {useLocation, useNavigate} from "react-router-dom";

const Navbar = ({ isOpen, setIsOpen }) => {
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    if (location.pathname !== "/") {
      // Ako nisi na "/" -> idi na "/"
      navigate("/");

      // Sačekaj da se ruta promeni, pa onda skroluj
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Blaga pauza da sačekamo učitavanje stranice
    } else {
      // Ako si već na "/" -> samo skroluj
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className={`${styles.navbar} ${isOpen ? styles.shifted : ""}`}>
      <a href={'/'} className={styles.logo}><img src={logo1}/><img src={logo2}/></a>

      <ul className={styles.navLinks}>
        <li><a onClick={() => handleNavigation("onama")}>Ko smo mi?</a></li>
        <li><a onClick={() => handleNavigation("ponuda")}>Šta je u ponudi?</a></li>
        <li><a onClick={() => handleNavigation("izbor")}>Koji ples biraš?</a></li>
        <li><a onClick={() => window.location.href="/news"}>Šta je novo?</a></li>
        <li><a onClick={() => handleNavigation("kontakt")}>Pleši sa nama</a></li>
      </ul>

      {/* Hamburger dugme */}
      <div className={styles.hamburger} onClick={toggleMenu}>
        <div className={styles.line}></div>
        <div className={styles.line}></div>
        <div className={styles.line}></div>
      </div>
    </header>
  );
};

export default Navbar;
